import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import UserModal from './UserModal';
import NotificationToast from './NotificationToast';
import './UserManagement.css';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const EmployeeManagement = ({ onUpdate }) => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [fixedRole, setFixedRole] = useState('employee');
  const [notification, setNotification] = useState('');
  const notificationTimeoutRef = useRef(null);

  useEffect(() => {
    fetchEmployees();
  }, []);

  const fetchEmployees = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/users`);
      const employeesList = response.data.filter(user => user.role === 'employee');
      setEmployees(employeesList);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching employees:', error);
      setLoading(false);
    }
  };

  const handleCreateEmployee = () => {
    setEditingUser(null);
    setFixedRole('employee');
    setShowModal(true);
  };

  const handleEdit = (user) => {
    setEditingUser(user);
    setFixedRole(null);
    setShowModal(true);
  };

  const handleDelete = async (userId) => {
    if (!window.confirm('Are you sure you want to delete this employee?')) return;

    try {
      await axios.delete(`${BASE_URL}/api/users/${userId}`);
      handleSuccess('Employee deleted successfully');
      fetchEmployees();
      if (onUpdate) onUpdate();
    } catch (error) {
      alert(error.response?.data?.message || 'Error deleting employee');
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    setEditingUser(null);
    setFixedRole('employee');
    fetchEmployees();
    if (onUpdate) onUpdate();
  };

  const handleSuccess = (message) => {
    if (notificationTimeoutRef.current) {
      clearTimeout(notificationTimeoutRef.current);
    }
    setNotification(message);
    notificationTimeoutRef.current = setTimeout(() => {
      setNotification('');
    }, 5000);
  };

  useEffect(() => {
    return () => {
      if (notificationTimeoutRef.current) {
        clearTimeout(notificationTimeoutRef.current);
      }
    };
  }, []);

  if (loading) return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <p>Loading employees...</p>
    </div>
  );

  return (
    <div className="user-management">
      <NotificationToast message={notification} />
      <div className="header-section">
        <h1>Employee Management</h1>
        <button className="btn-primary" onClick={handleCreateEmployee}>
          + Add Employee
        </button>
      </div>

      {employees.length === 0 ? (
        <div className="empty-hierarchy-state">
          <div className="empty-icon">👤</div>
          <h3>No Employees Found</h3>
          <p>Start building your team by adding your first employee.</p>
          <button className="btn-primary" onClick={handleCreateEmployee}>
            + Add Your First Employee
          </button>
        </div>
      ) : (
        <div className="users-list">
          {employees.map(employee => (
            <div key={employee.id || employee._id} className="user-card">
              <div className="user-card-header">
                <div className="user-info-inline">
                  <h3>{employee.name}</h3>
                  <span className="user-username">@{employee.username}</span>
                </div>
                <div className="user-actions">
                  <button className="btn-edit-client" onClick={() => handleEdit(employee)}>Edit</button>
                  <button className="btn-delete-client" onClick={() => handleDelete(employee.id || employee._id)}>Delete</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {showModal && (
        <UserModal
          user={editingUser}
          fixedRole={fixedRole}
          onClose={handleModalClose}
          onSuccess={handleSuccess}
        />
      )}
    </div>
  );
};

export default EmployeeManagement;

